export const currencyFormat = (
  amount: string | number,
  currency: string = "NGN"
) =>
  Number(amount).toLocaleString("en-NG", {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
  });

export const handleAutoLogout = (timeInMilliseconds: number) => {
  const events = [
    "load",
    "mousemove",
    "mousedown",
    "click",
    "scroll",
    "keypress",
  ];

  let timer: any;
  timer = setTimeout(() => {
    resetTimer();
    Object.values(events).forEach((item) => {
      window.removeEventListener(item, resetTimer);
    });


    localStorage.removeItem("");
    window.location.pathname = "/login";
  }, timeInMilliseconds);

  const resetTimer = () => {
    if (timer) clearTimeout(timer);
  };
};
